import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { i18n } from "../plugins/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:lang",
    name: "home",
    component: Home
  },
  {
    path: "/:lang/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/:lang/work",
    name: "work",
    component: () => import(/* webpackChunkName: "work" */ "../views/Work.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const lang = to.params.lang;
  if (!["en", "jp"].includes(lang)) return next("en");

  if (i18n.locale !== lang) {
    i18n.locale = lang;
  }

  return next();
});

export default router;
